import { DEFAULT_SUPERVISOR_CREDENTIALS } from "../constants";

type HistoryPersonArgs = {
  credentials?: Nullable<string>;
  name?: Nullable<string>;
};

function joinParts(parts: (string | undefined)[]) {
  return parts.filter(Boolean).join(", ");
}

function clean(value?: Nullable<string>) {
  return value?.trim() || undefined;
}

export function formatHistoryAuthor({
  credentials,
  name,
  signature,
}: HistoryPersonArgs & { signature?: Nullable<string> }) {
  const displayName = clean(signature) ?? clean(name);

  if (!displayName) return undefined;

  return joinParts([displayName, clean(credentials)]);
}

export function formatHistorySupervisor({ credentials, name }: HistoryPersonArgs) {
  const displayName = clean(name);

  if (!displayName) return undefined;

  return joinParts([displayName, clean(credentials) ?? DEFAULT_SUPERVISOR_CREDENTIALS]);
}
